export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9859.dc64409a.jpg";